import { useEffect } from 'react';

export const SCROLL_ID_PREFIX = 'scroll-container';

export const useScrollHandling = (
  currentNavigation: number[],
  isOpen: boolean // isOpen is required to identify open/close event for mobile
) => {
  useEffect(() => {
    if (isOpen) {
      const scrollContainer = document.getElementById(
        `${SCROLL_ID_PREFIX}-${currentNavigation.length}`
      );
      const scrollContainerMobile = document.getElementById(SCROLL_ID_PREFIX);

      scrollContainer?.scroll?.({ top: 0 });
      scrollContainerMobile?.scroll?.({ top: 0 });
    }
  }, [currentNavigation, isOpen]);
};
